module.exports = __webpack_public_path__ + "img/포트리스.b4c71a37.png";